import React, { useState } from 'react'
import { Spinner } from "react-bootstrap";

const Drag = ({ handleFileUpload, handleUpload, uploadLoading, inputRef }) => {
    const [isDragActive, setIsDragActive] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragActive(true);
    };

    const handleDragLeave = () => {
        setIsDragActive(false);
    };

    const handleDrop = async (e) => {
        e.preventDefault();
        setIsDragActive(false);
        const file = e.dataTransfer.files[0];
        await handleFileUpload(file);
    };

    return (
        <div
            className={`upload__container ${isDragActive ? "drag__active" : ""
                }`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            
            {uploadLoading ? <div className='loading__container'>
                <Spinner />
            </div>:""}
            {isDragActive ? (
                <p>Drop the file here</p>
            ) : (
                <>
                    <h1>Drag & Drop</h1>
                    <h1 className="or">Or</h1>
                    <input
                        onChange={handleUpload}
                        id="upload"
                        className="d-none"
                        type="file"
                        ref={inputRef}
                        accept=".pdf,.jpg,.jpeg,.png,.mov,.mp4,.xls,.xlsx,.csv"
                    />
                    <label htmlFor="upload">Upload</label>
                </>
            )}
        </div>
    )
}

export default Drag